import React from 'react';
import PropTypes from 'prop-types';
import './styles/style.scss';

const Spacer = props => (
  <div className="c-vi-spacer" style={{ height: props.height }}>
    {props.children}
  </div>
);

Spacer.propTypes = {
  children: PropTypes.node.isRequired,
  height: PropTypes.string.isRequired,
};

export default Spacer;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/visualIdentity/Spacer.jsx